import React from 'react';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';
import { NumericFormat } from 'react-number-format';

interface InputUSDProps {
  name: string;
  label?: string;
  fullWidth?: boolean;
  exchangeRate?: number;
  helperText?: string;
  [x: string]: any;
}

const InputUSD = ({
  name,
  label,
  fullWidth,
  exchangeRate = 4100,
  helperText,
  ...props
}: InputUSDProps) => {
  const [field, meta, helpers] = useField(name);

  const renderHelperText = () => {
    if (meta.touched && meta.error) {
      return meta.error;
    }

    let conversionText = '';
    if (exchangeRate && field.value) {
      const numericValue = Number(field.value);
      if (!isNaN(numericValue)) {
        const converted = new Intl.NumberFormat('es-CO', {
          style: 'currency',
          currency: 'COP',
          minimumFractionDigits: 0,
        }).format(numericValue * exchangeRate);
        conversionText = `≈ ${converted} COP`;
      }
    }

    if (helperText && conversionText) {
      return `${helperText} (${conversionText})`;
    }

    return conversionText || helperText || '';
  };

  return (
    <NumericFormat
      customInput={TextField}
      name={field.name}
      label={label}
      fullWidth={fullWidth}
      value={field.value ?? ''}
      error={meta.touched && Boolean(meta.error)}
      helperText={renderHelperText()}
      onBlur={field.onBlur}
      onValueChange={(values) => {
        helpers.setValue(values.value);
      }}
      decimalScale={6}
      fixedDecimalScale={false}
      allowNegative={false}
      suffix=" USD"
      thousandSeparator="."
      decimalSeparator=","
      {...props}
      autoComplete="off"
    />
  );
};

export default InputUSD;
